import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="enter-as-tab"
export default class extends Controller {
  handle(event) {
    if (event.key !== "Enter" || event.isComposing) return
    if (event.defaultPrevented) return

    const target = event.target
    if (!(target instanceof HTMLElement)) return

    if (this.isMultilineField(target)) return

    event.preventDefault()
    this.moveFocus(target, event.shiftKey ? -1 : 1)
  }

  isMultilineField(element) {
    return element.tagName === "TEXTAREA" || element.isContentEditable
  }

  moveFocus(currentElement, step) {
    const focusableElements = this.focusableElements()
    const currentIndex = focusableElements.indexOf(currentElement)

    if (currentIndex === -1) return

    const nextElement = focusableElements[currentIndex + step]
    if (nextElement) {
      nextElement.focus()
      if (nextElement instanceof HTMLInputElement && nextElement.type !== "checkbox" && nextElement.type !== "radio") {
        nextElement.select()
      }
      return
    }

    currentElement.blur()
  }

  focusableElements() {
    const selector = [
      "input:not([type='hidden'])",
      "select",
      "textarea",
      "button",
      "[tabindex]:not([tabindex='-1'])"
    ].join(",")

    return Array.from(this.element.querySelectorAll(selector)).filter((element) => {
      if (!(element instanceof HTMLElement)) return false
      if (element.hasAttribute("disabled")) return false
      if (element.getAttribute("aria-hidden") === "true") return false
      if (element.tagName === "INPUT" && element.getAttribute("readonly") !== null) return false
      return element.getClientRects().length > 0
    })
  }
}
